<template>
<!-- <div style="width:800px">
  <easyTable class="dragTable" :pData="{
    data:tableData,
    nTotal:4
  }" :config="col" border rowKey="id">
    <el-table-column label="排序" width="100" align="center" slot="first">
      <template slot-scope="scope">
       No:{{scope.$index}}
      </template>
    </el-table-column>
  </easyTable>
</div> -->
<router-view></router-view>
</template>

<script>
import Sortable from 'sortablejs'
import easyTable from 'public/easyTable'
export default {
  data() {
    return {
      col: [{
          label: '日期',
          prop: 'date'
        },
        {
          label: '姓名',
          prop: 'name'
        },
        {
          label: '地址',
          prop: 'address'
        }
      ],
      dropCol: [{
          label: '日期',
          prop: 'date'
        },
        {
          label: '姓名',
          prop: 'name'
        },
        {
          label: '地址',
          prop: 'address'
        }
      ],
      tableData: [{
          id: '1',
          date: '2016-05-02',
          name: '王小虎1',
          address: '上海市普陀区金沙江路 100 弄'
        },
        {
          id: '2',
          date: '2016-05-04',
          name: '王小虎2',
          address: '上海市普陀区金沙江路 200 弄'
        },
        {
          id: '3',
          date: '2016-05-01',
          name: '王小虎3',
          address: '上海市普陀区金沙江路 300 弄'
        },
        {
          id: '4',
          date: '2016-05-03',
          name: '王小虎4',
          address: '上海市普陀区金沙江路 400 弄'
        }
      ]
    }
  },
  mounted() {
    //this.rowDrop()
  },
  components: {
    easyTable
  },
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this;
      Sortable.create(tbody, {
        animation: 880,
        delay: 0,
        ghostClass: 'drag-class',
        onEnd({
          newIndex,
          oldIndex
        }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/xunjian/index.vue